import React from 'react';
import { useCookies } from '../contexts/CookieContext';

const CookieSettings = () => {
  const { openPreferences, cookieConsent } = useCookies();

  if (!cookieConsent) return null;

  return (
    <button
      onClick={openPreferences}
      className="fixed bottom-4 right-4 z-30 flex items-center gap-2 rounded-md border border-white/10 bg-[#15151b] px-3 py-2 text-xs text-[#fffefa] shadow-lg shadow-black/40 transition-colors duration-200 hover:bg-[#1c1c25]"
      title="Gestionar cookies"
    >
      <svg className="h-4 w-4 text-[#0a84ae]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 100 4m0-4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 100 4m0-4v2m0-6V4" />
      </svg>
      <span>Cookies</span>
    </button>
  );
};

export default CookieSettings;
